export const NO_AXIS_SELECTED_VALUE = '';

// Free-form catalog metadata with no enum behind it — compare case-insensitively.
export const DATE_COLUMN_GROUP = 'date';
